import axios from 'axios'
import type {PcgReportGenerationJob, PcgReportGenerationJobAction} from '../models'

const API_URL = process.env.REACT_APP_API_URL ? `${process.env.REACT_APP_API_URL}/PcgReports` : undefined

const getApiUrl = () => {
  if (!API_URL) {
    throw new Error('REACT_APP_API_URL is not configured.')
  }
  return API_URL
}

export const startPcgReportGenerationJob = async (
  reportId: string,
  action: PcgReportGenerationJobAction
): Promise<PcgReportGenerationJob> => {
  const apiUrl = getApiUrl()
  const {data} = await axios.post<PcgReportGenerationJob>(`${apiUrl}/${reportId}/report-jobs`, {
    action,
  })
  return data
}

export const getPcgReportGenerationJob = async (jobId: string): Promise<PcgReportGenerationJob> => {
  const apiUrl = getApiUrl()
  const {data} = await axios.get<PcgReportGenerationJob>(`${apiUrl}/report-jobs/${jobId}`)
  return data
}

export const getActivePcgReportGenerationJob = async (
  reportId: string
): Promise<PcgReportGenerationJob | undefined> => {
  const apiUrl = getApiUrl()
  const response = await axios.get<PcgReportGenerationJob>(`${apiUrl}/${reportId}/report-jobs/active`, {
    validateStatus: (status) => status === 200 || status === 204,
  })

  if (response.status === 204) {
    return undefined
  }

  return response.data
}

export const downloadPcgReportGenerationJobFile = async (jobId: string): Promise<Blob> => {
  const apiUrl = getApiUrl()
  const {data} = await axios.get(`${apiUrl}/report-jobs/${jobId}/file`, {responseType: 'blob'})
  return data as Blob
}

